var _ = require('underscore');
var Marionette = require('marionette');
var FilterType = EY.Consultation.Lookups.FilterType;
var User = EY.Consultation.CurrentUser;

var Filter = Marionette.View.extend({
    modelEvents: {
        'change:count': function () { this.ui.count.html(this.model.get('count')); }
    },
    events: {
        'click @ui.filter': 'select'
    },
    tagName: 'li',
    template: '#predefinedFilter',
    ui: {
        count: '#count',
        filter: '#filter'
    },
    select: function () {
        this.model.collection.any(function (model) { return model.get('selected') && model.set('selected', false); });
        this.model.set('selected', true);
    }
});

var Filters = Marionette.CollectionView.extend({
    childView: Filter,
    className: 'dropdown-menu',
    tagName: 'ul',
    filter: function (child) {
        return child.get('type') === FilterType.Predefined;
    }
});

var Selection = Filter.extend({
    tagName: 'span',
    template: '#predefinedFilterSelection'
});

var Layout = Marionette.View.extend({
    collectionEvents: {
        'change:selected': 'select'
    },
    regions: {
        filters: { el: '#predefinedFilterList', replaceElement: true },
        option: '#option'
    },
    template: '#predefinedFilterLayout',
    ui: {
        select: '#select'
    },
    onRender: function () {
        var allowedRoles = _.filter(User.roles, function (role) {
            return /CountryAdministrator|CountryProfessionalPractice|Reviewer|UsRegionReviewer/i.test(role.roleId) ||
                (role.geographyTypePath === '/Area/Region/Country/SubCountry/' && /RegionAdministrator|RegionalProfessionalPractice/i.test(role.roleId));
        });
        if (allowedRoles.length > 0) {
            this.ui.select.removeClass("hidden");
        } else {
            this.ui.select.addClass("hidden");
        }
    },
    select: function (filter) {
        if (filter.get('type') === FilterType.Predefined) {
            this.ui.select.toggleClass('link-active', filter.get('selected'));
            this.getRegion('option').show(new Selection({ model: filter }));
        }
    }
   
});

module.exports.show = function (options) {
    var filters = options.queries;
    var region = options.region;
    var layout = new Layout({ collection: filters });

    region.show(layout);
    layout.getRegion('filters').show(new Filters({ collection: filters }));
};


// WEBPACK FOOTER //
// ./js/Modules/Home/HomePredefinedFilters.js